import Modal, { ModalProps } from 'components/containers/Modal/Modal';
import Button from 'components/generics/buttons/Button';
import Typography from 'components/generics/texts/Typography';
import { CANCEL_RECURRING_ACTION_MUTATION } from 'graphql/recurringActions/mutations/cancelRecurringActionMutation';
import { useLandaApiMutation } from 'hooks/api/graphql/landa_api';
import useRecurringActions from 'hooks/requests/account/useRecurringActions';
import { useState } from 'react';
import classes from './index.module.scss';

interface Props extends ModalProps {
  recurringActionId: string;
}

const CancelRecurringActionModal = ({
  recurringActionId,
  onClose,
  ...props
}: Props) => {
  const [loading, setLoading] = useState(false);
  const { request } = useRecurringActions();
  const [cancelRecurringActionMutation] = useLandaApiMutation(
    CANCEL_RECURRING_ACTION_MUTATION,
    {
      variables: {
        recurringActionId,
      },
    }
  );

  const onCancelRecurringAction = async () => {
    setLoading(true);
    await cancelRecurringActionMutation();
    request && (await request());
    onClose();
    setLoading(false);
  };

  return (
    <Modal
      onClose={onClose}
      className={classes.container}
      {...props}
    >
      <Typography className={classes.title}>
        Are you sure you want to cancel this recurring action?
      </Typography>
      <div className={classes.buttonsContainer}>
        <Button
          loading={loading}
          onClick={onCancelRecurringAction}
          className={classes.button}
        >
          Cancel recurring action
        </Button>
        <Button
          disabled={loading}
          onClick={onClose}
          className={classes.cancelButton}
        >
          Keep recurring action
        </Button>
      </div>
    </Modal>
  );
};

export default CancelRecurringActionModal;
